export enum JurorFormState {
  List = 'ListOfJurors',
  Rating = 'JurorRating',
}

export enum JurorRatingState {
  Create = 'Create',
  Link = 'Link',
}
